import React from 'react';
import { Icon } from 'antd';

function CreateNewFloorButton({ onClick, t }) {
  return (
    <div className="specific-floor-create-btn" onClick={onClick}>
      <Icon type="edit" className="specific-floor-create-btn__icon" />
      {t('cms.property.listing_management.floor_plan.modal.title')}
    </div>
  );
}

export default CreateNewFloorButton;
